import { formatPlanAmount, regularPrices } from "../../../shared/src/platform-plans";

// Drate's own pages say Drate is free to start until the plans.regular flag reaches their visitor;
// then they say what Regular costs, since setup opens on a paid plan choice. Copy written for Free
// stays where it is, with its Regular wording beside it, so turning the flag off restores every word.

export const regularMonth = formatPlanAmount(regularPrices.month.amount);
export const regularYear = formatPlanAmount(regularPrices.year.amount);

/** Picks a line's Free or Regular wording: `const pick = planCopy(regular); pick(free, paid)`. */
export function planCopy(regular: boolean) {
  return <T>(free: T, paid: T): T => (regular ? paid : free);
}

// Wording in Drate's Markdown (the guides) that depends on plans.regular, anywhere in a file:
// `{{free:…}}` shows without the flag and `{{regular:…}}` with it. Neither holds `}` or a line break.
const planWording = /\{\{(free|regular):([^}\n]*)\}\}/g;

/** Whether a Markdown file has wording for plans.regular. */
export const hasPlanWording = (source: string) => /\{\{(?:free|regular):/.test(source);

/** A Markdown file as one side of plans.regular reads it. */
export function planVariant(source: string, regular: boolean) {
  const side = regular ? "regular" : "free";
  return source.replace(planWording, (_, which: string, text: string) =>
    which === side ? text : "",
  );
}

/** The main button into setup. */
export const startLabel = (regular: boolean) => (regular ? "Get started" : "Start for free");
